<header>
  <app-header-university></app-header-university>
  <app-header-logged-in-user></app-header-logged-in-user>
</header>
